query GetContactDripSequenceProgressions($contactId: ID!) {
    contact(id: $contactId) {
        id
        name
        htmlUrl
        dripProgressions {
            id
            nextEditionSendTime
            numEditionsSent
            campaign {
                id
                name
                status
                htmlUrlPath
                editions {
                    totalCount
                }
            }
            nextEdition {
                id
                name
                emailTemplate {
                    id
                }
            }
        }
    }
}
